/**
 * Environment utilities for safe browser/Node.js environment detection
 */

import { getBaseUrl } from './url';

/**
 * Check if we're in development mode
 * Falls back to localhost detection if process.env is not available
 */
export function isDevelopment(): boolean {
  try {
    if (typeof process !== 'undefined' && process.env) {
      return process.env.NODE_ENV === 'development';
    }
  } catch {
    // Fall back to hostname detection
  }

  // Browser fallback: check if running on localhost
  return (
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
  );
}

/**
 * Check if we're in production mode
 */
export function isProduction(): boolean {
  try {
    if (typeof process !== 'undefined' && process.env) {
      return process.env.NODE_ENV === 'production';
    }
  } catch {
    // Fall back to hostname detection
  }

  // Browser fallback: assume production if not localhost
  return (
    typeof window !== 'undefined' &&
    window.location.hostname !== 'localhost' &&
    window.location.hostname !== '127.0.0.1'
  );
}

/**
 * Get the current environment (development, production, or test)
 */
export function getEnvironment(): 'development' | 'production' | 'test' | 'unknown' {
  try {
    if (typeof process !== 'undefined' && process.env) {
      const env = process.env.NODE_ENV;
      if (env === 'development' || env === 'production' || env === 'test') {
        return env;
      }
      return 'unknown';
    }
  } catch {
    // Fall back to hostname detection
  }

  if (typeof window !== 'undefined') {
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      return 'development';
    }
    return 'production';
  }

  return 'unknown';
}

export function getMeetingUrl(meetingId: string, password?: string): string {
  const suffix = password ? `#${password}` : '';
  return `${getBaseUrl()}/${meetingId}${suffix}`;
}
